import { ON_MOBILE_DEVICE_REGISTERED_BY_ID, ON_REGISTRATION_TOKEN_SAVED_BY_ID } from 'graphql/subscriptions';
import useGraphQLAuthToken from 'hooks/useGraphQLAuthToken';
import { useEffect } from 'react';
import { isMockedMode } from 'utils/isMockedMode';
import { subscribeToDocument } from 'utils/subscribeToDocument';

const useMobileDeviceRegistrationSubscription = (visitorId: string | undefined, onEvent: () => void) => {
  const getToken = useGraphQLAuthToken();

  useEffect(() => {
    // The Amplify client bypasses Apollo's MockedProvider, so in mocked modes it would fire real,
    // unauthenticated subscription requests.
    if (!visitorId || isMockedMode()) return;

    const cleanupMobileDeviceRegistered = subscribeToDocument(
      ON_MOBILE_DEVICE_REGISTERED_BY_ID,
      { visitorId },
      getToken,
      () => onEvent()
    );
    const cleanupRegistrationTokenSaved = subscribeToDocument(
      ON_REGISTRATION_TOKEN_SAVED_BY_ID,
      { visitorId },
      getToken,
      () => onEvent()
    );

    return () => {
      cleanupMobileDeviceRegistered();
      cleanupRegistrationTokenSaved();
    };
  }, [visitorId, onEvent, getToken]);
};

export default useMobileDeviceRegistrationSubscription;
